import { useDispatch } from "react-redux";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import SignalsEmptyStateText from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsEmptyState/SignalsEmptyStateText";
import {
    setShouldAutoApplyCreatedSignal,
    setPreselectedSignalType,
} from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import type SignalsFilter from "../../../models/SignalsFilter/SignalsFilter";

import SignalsView from "./SignalsView";

const SignalsFilterView = (props: IFilterViewBaseProps<SignalsFilter>) => {
    const { filter } = props;
    const { CustomViewComponent } = filter.presentation;

    const dispatch = useDispatch();

    const handleCreateSignalClick = (signalType: SignalType): void => {
        dispatch(setShouldAutoApplyCreatedSignal(true));
        dispatch(setPreselectedSignalType(signalType));
    };

    if (CustomViewComponent) {
        return <CustomViewComponent signalType={filter.signalType} />;
    }

    if (filter.availableUISignals.length === 0) {
        return (
            <SignalsEmptyStateText
                signalType={filter.signalType}
                onAddSignalClick={() => handleCreateSignalClick(filter.signalType)}
            />
        );
    }

    return (
        <SignalsView
            {...props}
            onCreateSignal={handleCreateSignalClick}
        />
    );
};

export default SignalsFilterView;
